<script lang="ts">
    import LazyIcon from '$src/lib/components/LazyIcon/LazyIcon.svelte';
    import type { VoidFunction } from '$src/lib/common';
    import { showSomeElementsForNewerAppVersions } from './utils';
    import type { TWordpressFabricInGameTranslations } from '$src/lib/services/wordpress/types';

    export let onToggleGameFullScreen: VoidFunction;
    export let onOpenChat: VoidFunction;
    export let onExitGame: VoidFunction;

    export let inGameTranslations: TWordpressFabricInGameTranslations;

    const showLiveChat = showSomeElementsForNewerAppVersions();
</script>

<div
    class="flex min-h-[42px] flex-col text-white desktop-l:flex-row desktop-l:bg-white/0 desktop-l:p-0"
>
    <div class="mr-3xl pr-3xl">
        <slot name="wallet-balance-in-game" />
    </div>
    <div class="flex h-full w-full justify-evenly">
        <div class="flex items-center gap-2xs desktop-l:px-md">
            <slot name="likes-counter" />
        </div>
        {#if showLiveChat}
            <div class="h-full border-l border-grey-5/20"></div>
            <button
                class="flex items-center gap-2xs desktop-l:px-md"
                on:click={onOpenChat}
                data-testid="chat-button"
            >
                <LazyIcon icon="chat" class="h-md w-md" />
                <span class="desktop-l:hidden"
                    >{inGameTranslations?.drawer_live_chat ?? 'Live chat'}</span
                >
            </button>
        {/if}
        <div class="hidden h-full border-l border-grey-5/20 desktop-l:block"></div>
        <button
            class="hidden desktop-l:block desktop-l:px-md"
            data-testid="fullscreen-button"
            on:click={onToggleGameFullScreen}
        >
            <LazyIcon icon="expand" class="h-md w-md" />
        </button>
        <div class="h-full border-l border-grey-5/20"></div>
        <button
            class="flex items-center gap-2xs px-0 desktop-l:px-md"
            on:click={onExitGame}
            data-testid="exit-button"
        >
            <LazyIcon icon="exit" class="h-md w-md" />
            <span class="desktop-l:hidden"
                >{inGameTranslations?.drawer_exit_game ?? 'Exit game'}</span
            >
        </button>
    </div>
</div>
